import { useRoute } from '@react-navigation/native';

/**
 * route params에서 instanceId를 가져오는 hook
 * instanceId가 없는 경우 'default'를 반환
 */
export const useInstanceId = (): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { params } = useRoute<any>();

  const instanceId = params?.instanceId;

  if (!instanceId) {
    return 'default';
  }

  return String(instanceId);
};
